export const TaskItemSkeletonComponent = {
  templateUrl:
    'components/Skeletons/task-item-skeleton/task-item-skeleton.html',
};
